import type { FunctionComponent } from 'react';

import { window } from '../../../globals';

import Link from './Link';
import MailToLink from './MailToLink';
import type { MailToLinkProps } from './MailToLink';

const SUPPORT_CONFIG = window.support;

type SupportLinkProps = Omit<MailToLinkProps, 'email'>;

/**
 * Returns a link to either email support or to open an external support URL.
 * This can be configured in the config via app:support.
 */
const SupportLink: FunctionComponent<SupportLinkProps> = (props) => {
  if (!SUPPORT_CONFIG.enabled) {
    return (
      <span className="inline-block">
        {props.children}
      </span>
    );
  }

  switch (SUPPORT_CONFIG.type) {
    case 'email':
      return (
        <MailToLink
          email={SUPPORT_CONFIG.email}
          {...props}
      />
      );

    case 'external':
      return (
        <Link
          to={SUPPORT_CONFIG.url}
          {...props}
      />
      );

    default:
      return (
        <span className="inline-block">
          {props.children}
        </span>
      );
  }
};

export default SupportLink;
